import { render } from "./index.vue?vue&type=template&id=1fb0d387"
const script = {}

import exportComponent from "/Users/lucky02/Desktop/project/hw_businessManagement/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__